<template>
  <v-container v-if="variant">
    <v-row
      class="mb-4"
      no-gutters>
      <v-col cols="4">
        <v-container class="input_grid bordered bg-white mr-4">
          <CalcInputNumber
            :id="nodeId"
            field="acquisition_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="installation_and_transportation_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="special_foundation_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="other_costs_machine"
            :rules="[positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="residual_value_machine"
            :rules="[positive]" />

          <CalcOutput
            :id="locationId"
            outside-label
            unit="%"
            field="calculated_interest_rate_percentage_location" />

          <CalcOutput
            :id="nodeId"
            outside-label
            unit="€ je Stunde"
            field="imputed_cost_of_capital_machine" />
        </v-container>
      </v-col>
      <v-col cols="4">
        <v-container
          class="input_grid bordered bg-white ml-2 mr-4"
          fluid>
          <CalcInputNumber
            :id="nodeId"
            field="replacement_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="future_installation_and_transportation_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="future_special_foundation_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="future_disposal_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="future_other_costs_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="future_residual_value_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="useful_life_machine"
            :rules="[required, positive]" />

          <CalcOutput
            :id="nodeId"
            outside-label
            unit="€ je Stunde"
            field="imputed_depreciation_machine" />
        </v-container>
      </v-col>
      <v-col cols="4">
        <v-container class="input_grid bordered bg-white ml-2">
          <CalcInputNumber
            :id="nodeId"
            field="required_space_including_auxiliary_areas_machine"
            :rules="[required, positive]" />

          <CalcOutput
            :id="locationId"
            outside-label
            unit="€ je m2 je Stunde"
            field="costs_of_the_area_location" />

          <CalcOutput
            :id="nodeId"
            outside-label
            unit="€ je Stunde"
            field="workplace_area_costs_machine" />
        </v-container>
      </v-col>
    </v-row>
    <v-row
      class="bg-white bordered mt-4 ga-4 pa-4"
      no-gutters>
      <v-col cols="6">
        <CalcOutput
          :id="shiftModelId"
          outside-label
          unit="h je Jahr"
          field="machine_availability_after_deductions_shiftModel" />
      </v-col>
      <v-col cols="6">
        <CalcOutput
          :id="nodeId"
          outside-label
          unit="€ je Stunde"
          field="fixed_costs_machine" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useSpaceStore } from "../../../../stores/spaceStore";
import CalcOutput from "../../../../components/Elements/CalcOutput.vue";
import { useTreeStore } from "@/stores/treeStore";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";
import { useTranslation } from "i18next-vue";
import { useCommonRules } from "@/validations/common";

const { t } = useTranslation();
const { required, positive } = useCommonRules(t);

const spaceStore = useSpaceStore();
const treeStore = useTreeStore();

const variant = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const locationId = computed(() => {
  return treeStore.elementLocation[props.nodeId];
});

const shiftModelId = computed(() => {
  return spaceStore.calculationElements[
    spaceStore.calculationElements[props.nodeId].parent
  ].shift_model_part;
});

onMounted(() => {
  variant.value = spaceStore.getElement(props.nodeId);
});
</script>
